var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7,
    fill: "white",
    stroke: "#006FBA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81726 3C8.00677 3 8.15905 3.05865 8.27411 3.17594C8.38917 3.28633 8.4467 3.43122 8.4467 3.61061C8.4467 3.79 8.38917 3.93834 8.27411 4.05563C8.15905 4.16602 8.00677 4.22122 7.81726 4.22122C7.63452 4.22122 7.48562 4.16602 7.37056 4.05563C7.26227 3.93834 7.20812 3.79 7.20812 3.61061C7.20812 3.43122 7.26227 3.28633 7.37056 3.17594C7.48562 3.05865 7.63452 3 7.81726 3ZM8.49746 10.3066H10V11H6V10.3066H7.64467V6.23933H6.05076V5.54593H8.49746V10.3066Z",
    fill: "#006FBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.1863d99e16cac140c8b4d8bb1dccd394.svg";
export { ForwardRef as ReactComponent };